import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoggerService } from './logger.service';
import { SearchEmployeeDialogComponent } from 'src/app/components/search-employee-dialog/search-employee-dialog.component';

var TAG = "SearchEmployeeDialogService";

@Injectable({
    providedIn: 'root'
})
export class SearchEmployeeDialogService {

    static ACTION_SEARCH_ALL = 1;

    constructor(private log: LoggerService,
        private modalService: NgbModal
    ) { }


    openDialog(actionCase: number , onlyTherapist?:boolean) {
        // console.log('open Dialog');
        this.log.d(TAG, 'open Dialog');
        const modalRef = this.modalService.open(SearchEmployeeDialogComponent , { size: 'lg', centered: true, backdrop: 'static'});

        console.log('onlyTherapist = '+onlyTherapist);
        modalRef.componentInstance.actionCase = actionCase;
        modalRef.componentInstance.onlyTherapist = onlyTherapist;
        // modalRef.componentInstance.status = status;
        // modalRef.componentInstance.tableKeyValue = tableKeyValue;



        return modalRef;

    }




}
